<template>
    <div
        class="md-map fashion"
        v-if="show && lat && lng && !isHideSchoolMap"
        :style="{ marginBottom }"
    >
        <module-box
            :fullColumn="fullColumn"
            :topSpacing="topSpacing"
            :btmSpacing="btmSpacing"
            :mobileNoMargin="mobileNoMargin"
            :mobileTopSpacing="mobileTopSpacing"
            :mobileBtmSpacing="mobileBtmSpacing"
            noPadding
            noMargin
        >
            <div v-if="title" class="mg-title" v-html="formatFontSize(title, 20)"></div>
            <div class="map-content" :style="contentStyle">
                <div
                    class="map-container"
                    :class="{
                        noscore: !(
                            listingWalkScore && listingWalkScore.walkscore > 0
                        )
                    }"
                    :style="containerStyle"
                >
                    <div
                        v-if="
                            listingWalkScore && listingWalkScore.walkscore > 0
                        "
                        class="work-score"
                    >
                        <span class="score">
                            <span class="value">
                                {{ listingWalkScore.walkscore }}
                            </span>
                            <span class="label">{{
                                $t('md-map.walkScore')
                            }}</span>
                        </span>
                        <span
                            v-if="listingWalkScore.description"
                            class="info"
                        >{{ listingWalkScore.description }}</span
                        >
                    </div>
                    <div v-if="replace" class="map-replace">
                        <iframe
                            frameborder="0"
                            scrolling="no"
                            marginheight="0"
                            marginwidth="0"
                            :src="`https://maps.google.com/maps?q=${lat},${lng}&z=${
                                parseInt(zoom) || 14
                            }&output=embed`"
                            :style="{
                                width: showGMap ? '100%' : '0%',
                                height: '100%'
                            }"
                            @load="replaceMapLoad = true"
                        ></iframe>
                    </div>
                    <component
                        :is="componentName"
                        v-else-if="canLoadMap && mapShow"
                        :zoom="zoom"
                        :mapConfig="mapConfig"
                        :tools="calTools"
                        :center="center"
                        :address="address"
                        :autoCenter="autoCenter"
                        :mapChangeEvent="mapChangeEvent"
                        :markerData="markerData"
                        :markerEventMap="markerEventMap"
                        @mapLoad="mapLoad"
                        @click="mapClick"
                    ></component>
                </div>
                <map-tab
                    v-if="tabs && tabs.length"
                    :showCollapse="showCollapse"
                    v-model:replace="replace"
                    :tabs="tabs"
                    :selectTab="selectTab"
                    :houseLimit="houseLimit"
                    @updateMarkerEvent="updateMarkerEvent"
                    @updateMarkerData="updateMarkerData"
                    @doMapEvent="doMapEvent"
                    @updateMapClickEvent="updateMapClickEvent"
                ></map-tab>
            </div>
            <AttomDesc v-if="showDisclaimer" class="near-by-disclaimer" :content="$t('md-map.schoolDataProvided')" />
        </module-box>
    </div>
</template>

<script>
import { mapState as rootMapState } from 'pinia';
import { usePageStore } from '@/store';
import common from '../index';
import mapTab from './map-tab.vue';
import { defineAsyncComponent } from 'vue';


export default {
    mixins: [common],
    computed: {

        ...rootMapState(usePageStore, {
            'page': store => store.page || {}
        }),
        calTools() {
            if (
                !this.isMobileSize &&
                this.listingWalkScore &&
                this.scoreTools
            ) {
                return this.scoreTools;
            } else {
                return this.tools;
            }
        },
        
        componentName({ page }) {
            return page.map?.type === 'google' ? 'Map' : 'hereMap';
        }
    },
    components: {
        Map: defineAsyncComponent(() =>
            import(
                /* webpackChunkName: "map_fashion"*/ '@/components/map/fashion.vue'
            )),
        hereMap: defineAsyncComponent(() =>
            import(
                /* webpackChunkName: "map-here_fashion"*/ '@/components/map-here/fashion.vue'
            )),
        mapTab
    }
};
</script>

<style lang="scss">
@import '../../../theme/media.scss';
@import '../../../theme/mixin.scss';

.md-map.fashion {
    .mg-scrollbar {
        ::-webkit-scrollbar-track-piece {
            background-color: #2f374f;
        }
        ::-webkit-scrollbar-thumb {
            border: 2px solid #2f374f;
        }
    }
    .mg-title {
        // letter-spacing: 1px;
        line-height: 1.2;
        padding-bottom: 30px;
        @include media-600 {
            font-size: var(--mg-title-size-mobile);
            letter-spacing: 3px;
            line-height: 1.25;
            padding-bottom: 20px;
        }
    }
    .map-content {
        display: flex;
        height: 580px;
        .map-container {
            flex-grow: 1;
            height: 100%;
            position: relative;
            padding-top: 66px;
            .work-score {
                z-index: 1;
                position: absolute;
                width: 100%;
                height: 66px;
                left: 0;
                top: 0;
                display: flex;
                .score {
                    flex: none;
                    width: 110px;
                    height: 100%;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;
                    @include color-theme('background-color');
                    color: #ffffff;
                    .value {
                        font-size: 24px;
                        font-family: var(--font-title);
                        letter-spacing: 1.33px;
                        line-height: 29px;
                    }
                    .label {
                        margin-top: 2px;
                        font-size: 12px;
                        letter-spacing: 0.67px;
                        line-height: 14px;
                    }
                }
                .info {
                    background-color: #f5f6fa;
                    position: relative;
                    flex: 1;
                    display: flex;
                    align-items: center;
                    height: 100%;
                    padding-left: 24px;
                    font-size: 15px;
                    font-family: var(--font-bold);
                    letter-spacing: 0.68px;
                    color: #4a4a60;
                }
            }
            .map-replace {
                position: relative;
                width: 100%;
                height: 100%;
            }
            &.noscore {
                padding-top: 0;
            }
        }
        @include media-600 {
            height: auto;
            display: block;
            .map-container {
                width: 100%;
                height: 100vw;
                border-top: 1px solid #f0f1f5;
                border-bottom: 1px solid #f0f1f5;
                .work-score {
                    .score {
                        width: 100px;
                    }
                    .info {
                        font-size: 14px;
                        letter-spacing: 0.63px;
                    }
                }
                .gm-style .gmnoprint .gm-style-mtc {
                    margin-top: 71px;
                }
                &.noscore {
                    .gm-style .gmnoprint .gm-style-mtc {
                        margin-top: 5px;
                    }
                    .map-replace {
                        top: 0;
                    }
                }
            }
        }
    }
    .near-by-disclaimer {
        padding: 16px 0 0 0;
        color: var(--color-info);
        font-size: 12px;
        line-height: 16px;
        a.disclaimer {
            text-decoration: underline;
            @include color-theme();
        }
        @include media-600 {
            margin-top: 0;
            border-top: none;
            padding: 16px 15px;
        }
    }
    .gm-style .gmnoprint .gm-style-mtc {
        margin-top: 5px;
        &:first-child {
            margin-left: 5px;
        }
    }
    .gm-style-pbc {
        z-index: 4 !important;
        pointer-events: none;
    }
}
</style>
